import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderReseller from "../Components/Reseller/headerReseller";
import ListReseller from "../Components/Reseller/listReseller";
import ViewVrTransaction from "../Components/Reseller/viewVRHistory";
// import ViewReseller from "../Components/";

const ResellerRoutes = () => {
  return (
    <Routes>
      <Route path="/rental" element={<HeaderReseller></HeaderReseller>}></Route>
      <Route path="/rental_list" element={<ListReseller></ListReseller>}></Route>
      <Route path="/transaction_list" element={<ListReseller></ListReseller>}></Route>
      <Route path="/vr-transaction/view/:id" element={<ViewVrTransaction></ViewVrTransaction>}></Route>
      {/* <Route path="/agent/add" element={<AddTeamMember></AddTeamMember>}></Route>
      <Route
        path="/agent/edit/:id"
        element={<EditTeamMember></EditTeamMember>}
      ></Route> */}
      {/* <Route path="/reseller/view/:id" element={<ViewReseller />}></Route> */}
    </Routes>
  );
};

export default ResellerRoutes;
